import {
    createSelector,
    createEntityAdapter
} from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice"

const directReqAdapter = createEntityAdapter({})
const initialState = directReqAdapter.getInitialState()

export const directReqApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getdirectReq: builder.query({
            query: () => ({
                url: '/directreq',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result?.isError
                },
            }),
            transformResponse: responseData => {
                const loadeddirectReq = responseData.map(directReq => {
                    directReq.id = directReq._id
                    return directReq
                });
                return directReqAdapter.setAll(initialState, loadeddirectReq)
            },
            providesTags: (result, error, arg) => {
                if (result?.ids) {
                    return [
                        { type: 'directReq', id: 'LIST' },
                        ...result?.ids.map(id => ({ type: 'directReq', id }))
                    ]
                } else return [{ type: 'directReq', id: 'LIST' }]
            }
        }),

        addNewDirectReq: builder.mutation({
            query: (initialUserData) => {
                const formData = new FormData();
                // Append fields from initialUserData
                Object.entries(initialUserData).forEach(([key, value]) => {
                    formData.append(key, value);
                });

                return {
                    url: '/directreq',
                    method: 'POST',
                    body: formData,
                };
            },
            invalidatesTags: [
                { type: 'directReq', id: 'LIST' }
            ]
        }),

        // updatedirectReq: builder.mutation({
        //     query: (userData) => {
        //         const formData = new FormData();
        //         // Append fields from userData
        //         Object.entries(userData).forEach(([key, value]) => {
        //             formData.append(key, value);
        //         });

        //         return {
        //             url: "/directreq",
        //             method: 'PUT',
        //             body: formData,
        //         };
        //     },
        //     invalidatesTags: [
        //         { type: 'directReq', id: 'LIST' }
        //     ]
        // }),

        // updateuserReqstatus: builder.mutation({
        //     query: initialUserData => ({
        //         url: '/userreq/updatestatus',
        //         method: 'PUT',
        //         body: {
        //             ...initialUserData,
        //         }
        //     }),
        //     invalidatesTags: (result, error, arg) => [
        //         { type: 'userReq', id: arg.id }
        //     ]
        // }),
        // updateuserReqFinal: builder.mutation({
        //     query: initialUserData => ({
        //         url: '/userreq/final',
        //         method: 'PUT',
        //         body: {
        //             ...initialUserData,
        //         }
        //     }),
        //     invalidatesTags: (result, error, arg) => [
        //         { type: 'userReq', id: arg.id }
        //     ]
        // }),
        // deleteuserReq: builder.mutation({
        //     query: ({ id }) => ({
        //         url: `/userreq`,
        //         method: 'DELETE',
        //         body: { id }
        //     }),
        //     invalidatesTags: (result, error, arg) => [
        //         { type: 'userReq', id: arg.id }
        //     ]
        // }),
    }),
})

export const {
   useAddNewDirectReqMutation,
   useGetdirectReqQuery,
   //useUpdatedirectReqMutation,
} = directReqApiSlice

// returns the query result object
export const selectdirectReqResult = directReqApiSlice.endpoints.getdirectReq.select()

// creates memoized selector
const selectdirectReqData = createSelector(
    selectdirectReqResult,
    directReqResult => directReqResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAlldirectReq,
    selectById: selectdirectReqById,
    selectIds: selectdirectReqIds
    // Pass in a selector that returns the users slice of state
} = directReqAdapter.getSelectors(state => selectdirectReqData(state) ?? initialState)